import React, {useState, useEffect} from "react";

import FadeIn from './FadeIn';
import '../index.scss';
import Main from "./Main";
import Expertise from "./Expertise";
import Timeline from "./Timeline";
import Project from "./Project";
import Footer from "./Footer";
import Navigation from "./Navigation";
import Contact from "./Contact";

function Home() {
    const [mode, setMode] = useState<string>('dark');

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
            <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
            <FadeIn transitionDuration={700}>
                <Main/>
                <Expertise/>
                <Timeline/>
                <Project/>
                <Contact/>
            </FadeIn>
        <Footer />
    </div>
    );
}

export default Home;